'use strict';
var angular = require('angular');
var GeneralInfoEditService = /** @class */ (function () {
    function GeneralInfoEditService($http) {
        'ngInject';
        this._$http = $http;
        // Object to store our user properties
        this.current = null;
    }
    GeneralInfoEditService.prototype.handleSuccess = function (response) {
        return response;
    };
    GeneralInfoEditService.prototype.handleError = function (response) {
        return response;
    };
    GeneralInfoEditService.prototype.checkEmailAccountExists = function (email) {
        var request = this._$http.get("api/account/" + email);
        var accountExists = true;
        return (request.then(function (data) {
            if (data.status == 200) {
                // May be specifically check for status code of 200
                // and if customerId is not null to determine if account exists or not?
                if (data.data.errors.length > 0) {
                    accountExists = false;
                }
                if (data.data.response == true) {
                    accountExists = true;
                }
                else {
                    accountExists = false;
                }
                return (accountExists);
            }
            return (false);
        }, function (err) {
            if (err.status == 400 || err.status == 404) {
                // Maybe specifically check for status code of 400 or 404
                // to determine if account doesn't exist?
            }
            return (false);
        }));
    };
    GeneralInfoEditService.prototype.isValidPassword = function (oldPassword) {
        var request = this._$http.post('api/account/password', { password: oldPassword });
        return (request.then(function (data) {
            if (data.status == 200) {
                // May be specifically check for status code of 200
                // and if customerId is not null to determine if account exists or not?
                if (data.data.errors.length > 0) {
                    console.log('Wrong Password -> ', data.data.errors);
                    return (false);
                }
                else {
                    console.log('Password is Valid ');
                    return (true);
                }
            }
            console.log('Got Status error ->', data.status);
            return (false);
        }, function (err) {
            if (err.status == 400 || err.status == 404) {
                // Maybe specifically check for status code of 400 or 404
                // to determine if account doesn't exist?
            }
            console.log('Got Response error ->', err);
            return (false);
        }));
    };
    GeneralInfoEditService.prototype.updateAccount = function (acctId, user) {
        var request = this._$http.put('api/account/' + acctId, user);
        return (request.then(this.handleSuccess, this.handleError));
    };
    return GeneralInfoEditService;
}());
export default GeneralInfoEditService;
//# sourceMappingURL=general-info-edit.service.js.map